import { ESessionStatus } from "../../constants";
import { EServiceType, IGenericFilters } from "../../interfaces";
import { IFilterOption } from "../shared";

export const SESSION_DATE_FILTER_IDS = ["yesterday", "today", "tomorrow", "custom-date"];

export const SESSION_DATE_FILTER_IDS_SET = new Set(SESSION_DATE_FILTER_IDS);

export const SESSION_FILTER_OPTIONS: IFilterOption[] = [
  // Group 1: Date filters (indices 0-3) - First divider after index 3
  {
    id: "yesterday",
    label: "Yesterday",
  },
  {
    id: "today",
    label: "Today",
    default: true,
  },
  {
    id: "tomorrow",
    label: "Tomorrow",
  },
  {
    id: "custom-date",
    label: "Custom Date",
  },
  // Group 2: Session scope & Service filters (indices 4-6) - Second divider after index 6
  {
    id: "all-sessions",
    label: "All Sessions",
    default: true,
  },
  {
    id: "grooming",
    label: "Grooming",
  },
  {
    id: "walking",
    label: "Walking",
  },
  // Group 3: Status filters (indices 7+)
  {
    id: "unassigned",
    label: "Unassigned", // Maps to SCHEDULED status
  },
  {
    id: "unattended", 
    label: "Unattended", // Maps to NO_SHOW status
  },
];

export const SESSION_STATUS_FILTER_OPTIONS: IGenericFilters[] = [
  { value: ESessionStatus.COMPLETED, label: "Completed" },
  { value: ESessionStatus.SCHEDULED, label: "Scheduled" },
  { value: ESessionStatus.CANCELLED, label: "Cancelled" },
  { value: ESessionStatus.NO_SHOW, label: "No Show" },
  { value: ESessionStatus.RESCHEDULED, label: "Rescheduled" },
];

export const SERVICE_TYPE_FILTER_OPTIONS: IGenericFilters[] = [
  { value: EServiceType.SINGLE, label: "Single" },
  { value: EServiceType.SUBSCRIPTION, label: "Subscription" },
];
